
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("ltXJB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fa3aa46a79fdfab4$var$_react = $fa3aa46a79fdfab4$var$_interopRequireDefault((parcelRequire("gwFzn")));

var $5DTTe = parcelRequire("5DTTe");

var $fa3aa46a79fdfab4$var$_clock = $fa3aa46a79fdfab4$var$_interopRequireDefault((parcelRequire("kevJM")));
function $fa3aa46a79fdfab4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $fa3aa46a79fdfab4$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $fa3aa46a79fdfab4$var$_react.default.createElement($5DTTe.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $fa3aa46a79fdfab4$var$_clock.default
    }));
$fa3aa46a79fdfab4$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $fa3aa46a79fdfab4$var$_default = module.exports.default = $fa3aa46a79fdfab4$var$EmojiFrequentIcon;

});


//# sourceMappingURL=frequent.67753c39.js.map
